import {
    Badge,
    Box,
    Button,
    HStack,
    Input,
    InputGroup,
    InputRightElement,
    Switch,
    Table,
    Tbody,
    Td,
    Th,
    Thead,
    Tr,
    useColorModeValue
} from "@chakra-ui/react";
import React, { useEffect, useRef, useState } from "react";
import { searchBell } from "../../Roster/Bells/services";
import { SearchIcon } from "@chakra-ui/icons";
import { convertTo12HourFormat, isTimeGreater } from "../../../../utils/TimeUtils";
import { FaPlay, FaStop } from "react-icons/fa";

const BellTable = ({ rosterList }) => {
    const bgStatus = useColorModeValue("gray.400", "#1a202c");
    const colorStatus = useColorModeValue("white", "gray.400");

    const [searchQuery, setSearchQuery] = useState("");
    const [bellList, setBellList] = useState([]);
    const [playingBellId, setPlayingBellId] = useState(null); // Track which bell is playing
    const audioRef = useRef(null); // Single ref to manage audio

    useEffect(() => {
        fetchBellList();
    }, []);

    const fetchBellList = async () => {
        try {
            let requestDTO = {
                id: rosterList[0]?.id || "",
                number: "",
                code: "",
            };
            const response = await searchBell(requestDTO);
            if (response.status === 200) {
                setBellList(response.data);
            }
        } catch (e) {
            console.error("Error while fetching bell list:", e);
        }
    };

    const handlePlayPause = (bellId, url) => {
        if (playingBellId === bellId) {
            // Stop the current playing audio
            if (audioRef.current) {
                audioRef.current.pause();
                audioRef.current.currentTime = 0;
            }
            setPlayingBellId(null);
        } else {
            // Play new audio
            if (audioRef.current) {
                audioRef.current.pause();
            }
            audioRef.current = new Audio(url);
            audioRef.current.play();
            setPlayingBellId(bellId);
        }
    };

    return (
        <Box w="150%" p={8}>
            {/* Filters */}
            <HStack mb={4} spacing={4}>
                <InputGroup>
                    <Input
                        placeholder="Search Bell"
                        value={searchQuery}
                        onChange={(e) => setSearchQuery(e.target.value)}
                    />
                    <InputRightElement pointerEvents="none">
                        <SearchIcon color="gray.400" />
                    </InputRightElement>
                </InputGroup>
                <Button colorScheme="blue" onClick={() => console.log("Search!")}>
                    Search
                </Button>
            </HStack>

            {/* Table */}
            <Table variant="striped" colorScheme="gray">
                <Thead>
                    <Tr>
                        <Th>SN</Th>
                        <Th>Name</Th>
                        <Th>Play</Th>
                        <Th>Hour Time</Th>
                        <Th>Current status</Th>
                        <Th>Enabled</Th>
                        <Th>Status</Th>
                    </Tr>
                </Thead>
                <Tbody>
                    {bellList.map((bell, index) => (
                        <Tr key={bell.id}>
                            <Td>{index + 1}</Td>
                            <Td>{bell.name}</Td>

                            <Td>
                                <HStack>
                                    <Button
                                        onClick={() => handlePlayPause(bell.id, bell?.bell)}
                                        leftIcon={playingBellId === bell.id ? <FaStop /> : <FaPlay />}
                                        colorScheme={playingBellId === bell.id ? "red" : "blue"}
                                    >
                                        {playingBellId === bell.id ? "Stop" : "Play"}
                                    </Button>
                                </HStack>
                            </Td>

                            <Td>{convertTo12HourFormat(bell.hourTime)}</Td>
                            <Td bg={isTimeGreater(null, bell?.hourTime) ? "red.200" : "yellow.200"}>
                                {isTimeGreater(null, bell?.hourTime) ? "Played" : "Upcoming"}
                            </Td>
                            <Td>
                                <Switch isChecked={bell?.enabled === true || bell?.enabled === "true"} />
                            </Td>
                            <Td>
                                <Badge
                                    bg={bell.status === "Y" ? "green.400" : bgStatus}
                                    color={bell.status === "Y" ? "white" : colorStatus}
                                    fontSize="12px"
                                    p="2px 6px"
                                    borderRadius="8px"
                                >
                                    {bell.status === "Y" ? "Active" : "Inactive"}
                                </Badge>
                            </Td>
                        </Tr>
                    ))}
                </Tbody>
            </Table>
        </Box>
    );
};

export default BellTable;